@import '../../styles/mixins/_btalk-mixins.scss';
@import '../../styles/variables/_btalk-variables.scss';
@import '../../styles/classes.scss';
@import '../../styles/header-nav.scss';
@import '../../styles/buttons.scss';


:host {
  display: block;
}


